import { downloadDocument, uploadDocument } from '../../common/Utils';
import cross from "../../images/cross.png";
//import icon_upload from "../../images/icon_upload.png";
import React, { useState, useEffect } from "react";
import { Container, Row, Col, Stack, Table } from 'react-bootstrap';
import DeleteIcon from '@mui/icons-material/Delete';
import { DialogContent, Button, IconButton, Dialog, DialogTitle, DialogActions, Typography } from '@mui/material';
import { FILE_NAME_VALIDATION_ERROR } from '../constants';
import { fileNameValidation } from '../commonValidations';
import { t } from 'i18next';
//import PDFViewer from 'pdf-viewer-reactjs'

export const FileUploadMUI = (props) => {
    const [selectedFile, setSelectedFile] = useState();
    const [url, setUrl] = useState();
    const [logModalOpen, setLogModalOpen] = useState(false);
    const handleLogModalOpen = () => setLogModalOpen(true);
    const handleLogModalClose = () => setLogModalOpen(false);
    const [fileName, setFileName] = useState();
    // const [errorMessage, setErrorMessage] = useState({
    //     props.documentError: '',
    // });
    const allowedTypes = ["image/png", "image/jpg", "image/jpeg", "application/pdf"];
    const [documentDetails, setDocumentDetails] = useState({
        id: null,
        documentType: null,
        documentName: null,
        documentBlobName: null,
        documentPath: null,
        documentContainerName: "stakeholder",
        stakeholderType: props.stakeholderType,
        stakeholderDetailId: null,
        isActive: 1
    });
    const [documentDetailsArr, setDocumentDetailsArr] = useState([]);
    const [documentUploadDetails, setDocumentUploadDetails] = useState();
     useEffect(() => {
         if (props.documentList) {
             setDocumentDetailsArr(props.documentList);
        }
    }, [props.documentList]);
    const onUploadDocument = (e, type) => {
        if (allowedTypes.indexOf(e.target.files[0].type) < 0) {
            return;
        }
        if (e.target.files[0].name.split('.').length > 2) {
            props.setErrorMessage({
                ...props.errorMessage,
                [props.documentError]: "Double extension file detected",
            });
            return;
        }
        if (e.target.files[0].size >= 5000000) {
            props.setErrorMessage({
                ...props.errorMessage,
                [props.documentError]: "The file size should be less than 5MB",
            });

        }
        else if(fileNameValidation(e.target.files[0].name)) {
            props.setErrorMessage({
                ...props.errorMessage,
                [props.documentError]: FILE_NAME_VALIDATION_ERROR,
            });
          }
        else {
            setSelectedFile(e.target.files[0]);
            props.setErrorMessage({ ...props.errorMessage, [props.documentError]: "" });
            setDocumentDetails({
                ...documentDetails,
                documentType: type,
                stakeholderDetailId: props.stakeholderDetailId,
            })
            uploadDocument(e.target.files[0], type, callbackUpload, props.containerName);
        }
    }
    const callbackUpload = (response,type) => {
        setDocumentUploadDetails(response);
        var document = {
            id: null,
            documentType: type,
            documentName: response?.blobResponse?.fileName,
            documentBlobName: response?.blobResponse?.blobFileName,
            documentPath: null,
            documentContainerName: props.containerName ? props.containerName :  "stakeholder",
            stakeholderType: props.stakeholderType,
            stakeholderDetailId: props.stakeholderDetailId,
            isActive: 1
        }
        var tempArr = documentDetailsArr;
        if (document.documentName != null && document.documentBlobName != null) {
            tempArr.push(document);
            setDocumentDetailsArr(tempArr);
            props.callBackDocumentUpload(tempArr);
        }    
    }
    //useEffect(() => {
    //    if (documentUploadDetails) {
    //        setDocumentDetails({ ...documentDetails, documentName: documentUploadDetails?.blobResponse?.fileName, documentBlobName: documentUploadDetails?.blobResponse?.blobFileName });
    //    }
    //}, [documentUploadDetails]);
    //useEffect(() => {
    //    if (documentDetails.documentBlobName) {
    //        var tempArr = documentDetailsArr;
    //        tempArr.push(documentDetails);
    //        setDocumentDetailsArr(tempArr);
    //        props.callBackDocumentUpload(tempArr);
    //    }

    //}, [documentDetails.documentBlobName]);


    const deleteDocument = (blobFileName, documentType) => {
        let existingData = documentDetailsArr.filter((item) => item.documentType === documentType && item.documentBlobName === blobFileName);
        let tempArr = documentDetailsArr.filter((item) => item.documentBlobName !== blobFileName);
        if (existingData && existingData[0]) {
            if (existingData[0].id) {
                existingData[0].isActive = 0;
                tempArr?.push(existingData[0]);
            }
        }
        setDocumentDetailsArr(tempArr);
        props.callBackDocumentUpload(tempArr);
    };
    const onClickDocument = (e, blobFileName, documentName) => {
        e.preventDefault();
        downloadDocument(blobFileName, documentName, null, props.containerName);
    };
    const callbackDownload = (fileurl, fileName) => {
        setFileName(fileName);
        setUrl(fileurl);
        //let newWindow = window.open('/');
        //newWindow.onload = () => {
        //    newWindow.location = fileurl;
        //};
        //window.open(fileurl);
        handleLogModalOpen();
    };
    const openUrl = (url) => {
        let newWindow = window.open('/');
        if (newWindow.document.readyState === 'complete') {
            newWindow.location.assign(url);
        } else {
            newWindow.onload = () => {
                newWindow.location.assign(url);
            };
        }
    }
    return (
        <>
            <Stack direction='horizontal'>
                <Col xs={props.isViewFile === "true" ? 0 : 6} md={props.isViewFile === "true" ? 0 : 6}><div className="uploadFileText_registration" key={props.key}><Typography variant="caption" align="right" style={{ fontStyle: "italic" }}>{props.title}</Typography></div></Col>
                <Col xs={props.isViewFile === "true" ? 12 : 6} md={props.isViewFile === "true" ? 12 : 6}>
                    {documentDetailsArr?.filter(item => item.documentType === props.documentType && (item.isActive === 1 || item.isActive === 3) ).map(item => (
                        <div className={props.isViewFile === "true" ? "chooseFile_storage_viewFile" : "chooseFile_storage"}  key={props.key}>
                            <a onClick={(e) => onClickDocument(e, item.documentBlobName, item.documentName)}>{item.documentName}</a>
                            <IconButton size='small' className='icon_button_grower_pre_reg' color="primary" aria-label="search" key={props.key}
                                onClick={() => deleteDocument(item.documentBlobName, item.documentType)} hidden={props.isViewOnly} disabled={props.disabled ? true : false}>
                                <DeleteIcon color='error' fontSize='inherit' />
                                </IconButton>
                        </div>
                    ))
                    }
                    {(documentDetailsArr)?.filter(item => item.documentType === props.documentType && (item.isActive === 1 || item.isActive === 3)).length == 0 ?
                        <label className="chooseFile_storage" hidden={props.isViewOnly}>
                            <input type="file" accept="image/png, image/jpg, image/jpeg ,.doc, .pdf" key={props.key}
                            capture="filesystem"
                                style={{ display: "none" }}
                                onChange={(e) => onUploadDocument(e, props.documentType)} disabled={props.disabled? true: false} />
                            {t('preReg.uploadFile')}
                        </label>  : null}   
                    </Col>
            </Stack>
            <Stack hidden={props.isViewOnly}>
                <Col xs={12} md={12}> <Typography variant="subtitle2" fontSize="1.8vh"  color="green">{t('preReg.uploadFileTypeNote')}</Typography></Col>
             </Stack>
             {props?.documentError && <div className='mandatory_field'>{props?.errorMessage[props?.documentError]}</div>}
              <Dialog maxWidth='xl' fullWidth open={logModalOpen}>
                <DialogContent>
                    {(fileName?.indexOf('.pdf') > 0 || fileName?.indexOf('.PDF') > 0) ? openUrl(url)
                     : <img src={url} ></img>}

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleLogModalClose}>Close</Button>
                </DialogActions>
            </Dialog> 
        </>       
     )
}